import React from "react";

function WebTypeSiteDetailsStep({ handleChange, formData }) {
  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="pt-3 mt-3">
          <h2 className="h6 pb-1 mb-3 color_grey">
            Great! Please Select Your Website Needs.
          </h2>
        </div>

        <div className="col-lg-12">
          <div className="row row-cols-1 row-cols-sm-1 g-3 g-sm-4 pb-3 pb-sm-4 mb-xl-2">
            {/* Infrastructure */}
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Infrastructure
              </label>
              <select
                className="form-select form-select-lg choices__input"
                name="web-infrastructure"
                onChange={handleChange}
                value={formData["web-infrastructure"] || ""}
                style={{ maxWidth: "300px" }}
              >
                <option value="">Select...</option>
                <option value="Wordpress (CMS)">Wordpress (CMS)</option>
                <option value="Static (HTML - CSS - JS)">
                  Static (HTML - CSS - JS)
                </option>
                <option value="ReactJS">ReactJS</option>
                <option value="NextJS">NextJS</option>
                <option value="Not Sure">Not Sure</option>
              </select>
            </div>

            {/* Design Level */}
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Design Level
              </label>
              <select
                className="form-select form-select-lg choices__input"
                name="design-level"
                onChange={handleChange}
                value={formData["design-level"] || ""}
                style={{ maxWidth: "300px" }}
              >
                <option value="">Select...</option>
                <option value="Client's Request (Design Files Available).">
                  Client's Request (Design Files Available).
                </option>
                <option value="Basic or Very Simple Design.">
                  Basic or Very Simple Design.
                </option>
                <option value="Custom and Professional Design.">
                  Custom and Professional Design.
                </option>
              </select>
            </div>

            {/* Site Type */}
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Site Type
              </label>
              <select
                className="form-select form-select-lg choices__input"
                name="site-type"
                onChange={handleChange}
                value={formData["site-type"] || ""}
                style={{ maxWidth: "300px" }}
              >
                <option value="">Select...</option>
                <option value="Product, Company, or Service Presentation">
                  Product, Company, or Service Presentation
                </option>
                <option value="News, Forum, Magazine, or Blog">
                  News, Forum, Magazine, or Blog
                </option>
                <option value="Online Reservation">
                  Online Reservation (Hotel/Accommodation, Flight Tickets,
                  Restaurant, Events, etc.)
                </option>
                <option value="Marketplace">
                  Marketplace (Real Estate, Car Rentals, Freelance Job Ads,
                  etc.)
                </option>
              </select>
            </div>
          </div>

          {/* Extra Options */}
          <div className="row">
            <div className="col-lg-12">
              <label className="form-label">Extra Options</label>
            </div>
            <div className="col-lg-12">
              <div className="row row-cols-1 row-cols-md-1 gy-3 gx-4">
                {/* Payment Infrastructure */}
                <div className="col">
                  <div className="form-check mb-0">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="payment"
                      name="extra-options"
                      onChange={handleChange}
                      checked={
                        formData["extra-options"]?.includes(
                          "Payment Infrastructure"
                        ) || false
                      }
                      value="Payment Infrastructure"
                    />
                    <label htmlFor="payment" className="form-check-label">
                      Payment Infrastructure
                    </label>
                  </div>
                </div>

                {/* Third-Party Integrations */}
                <div className="col">
                  <div className="form-check mb-0">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="3d-integration"
                      name="extra-options"
                      onChange={handleChange}
                      checked={
                        formData["extra-options"]?.includes(
                          "Third-Party Integrations"
                        ) || false
                      }
                      value="Third-Party Integrations"
                    />
                    <label
                      htmlFor="3d-integration"
                      className="form-check-label"
                    >
                      Third-Party Integrations
                    </label>
                  </div>
                </div>

                {/* Multi-Language */}
                <div className="col">
                  <div className="form-check mb-0">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="multi-language"
                      name="extra-options"
                      onChange={handleChange}
                      checked={
                        formData["extra-options"]?.includes("Multi-Language") ||
                        false
                      }
                      value="Multi-Language"
                    />
                    <label
                      htmlFor="multi-language"
                      className="form-check-label"
                    >
                      Multi-Language
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WebTypeSiteDetailsStep;
